import "./style.css";

const FNumber = ({ label, name, value, setValue, error, required }: any) => {
  return (
    <div className="f-number-container">
      <label htmlFor={name} className={`f-number-label ${error ? "error" : ""}`}>
        {label}
        {required && <span className="f-number-required"> *</span>}
      </label>
      {error && <small className="f-number-error">{error}</small>}
    </div>
  );
};

export default FNumber;
